import { ReactNode } from "react"

import { PageHeader } from "components/Header/PageHeader"
import { IS_STAGING } from "utils/env-management"

interface Props {
    title?: string
    children?: ReactNode
    hideTitle?: boolean
}

export function PageHeaderWithHero(props: Props) {
    return (
        <>
            <PageHeader openLogo={{ newTab: true }} />
            {!props.hideTitle && (
                <div className="header">
                    <div className="header__logo">
                        {IS_STAGING && <sub style={{ fontSize: "14px" }}>[Staging]</sub>}
                    </div>
                    {props.title !== "" && (
                        <h1 className="header__title">
                            {props.title || "Подбор психолога"}
                            {IS_STAGING && <sub style={{ fontSize: "14px" }}>[Staging]</sub>}
                        </h1>
                    )}
                    {props.children}
                </div>
            )}
        </>
    )
}
